import { ApiConnector, GET, POST } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/promo-groups', true);
    return {
        GetTags: async (data, query) => await API(GET, '/tags', false, query).call(data),
        GetAttendance: async (data, query, params) =>
            await API(GET, `/${params.group_id}/attendance`, false, query).call(data),
        SaveAttendance: async (data, query, params) =>
            await API(POST, `/${params.group_id}/attendance`, false, query).call(data, true),
    };
})();
